export const name = 'gvImage';

export const fits = ['fill', 'contain', 'cover'] as const;
